import React from 'react';
import StaffPhotoProfile from './StaffPhotoProfile';
import { Button, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import CustomAvatar from '@src/components/CustomAvatar';
import { generateInitialsHelper } from '@src/helpers/Helpers';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@src/store/hooks';
import * as Styled from '../Main/Sidebar/BusinessProfile/BusinessProfile.styles';
import { PanelTransitionProps } from '@src/styles/panelTransitions';

interface Props extends PanelTransitionProps {
	onHide: () => void;
	setChangePasswordDialogVisible: (isVisible: boolean) => void;
}

const UserProfile: React.FC<Props> = ({
	onHide,
	setChangePasswordDialogVisible,
	isExiting,
	onAnimationEnd,
}) => {
	const currentUser = useAppSelector((state) => state.currentUser.value);
	const { isReadOnly } = useAppSelector((state) => state.UI);

	const { t } = useTranslation();
	if(window.config?.APP_ENV_NAME==='cvparc-shadow')return <StaffPhotoProfile onHide={onHide} isExiting={isExiting} onAnimationEnd={onAnimationEnd}/>;

	return (
		<Styled.BusinessProfileContainer
			$isExiting={isExiting}
			onAnimationEnd={onAnimationEnd}
		>
			<Styled.Header>
				<IconButton onClick={onHide} size="large">
					<ArrowBack />
				</IconButton>

				<h3>{t('Profile')}</h3>
			</Styled.Header>

			<Styled.Body>
				<Styled.Section>
					{currentUser && (
						<div>
							<Styled.SectionHeader>
								<h5>{t('Personal Profile')}</h5>
							</Styled.SectionHeader>

							<Styled.AvatarContainer>
								<CustomAvatar
									src={
										currentUser?.profile?.large_avatar ??
										currentUser?.profile?.avatar
									}
									generateBgColorBy={currentUser.username}
								>
									{generateInitialsHelper(currentUser.username)}
								</CustomAvatar>
							</Styled.AvatarContainer>

							<Styled.UsernameContainer>
								<h3>{currentUser.username}</h3>
								<span>
									{currentUser.first_name + ' ' + currentUser.last_name}
								</span>
							</Styled.UsernameContainer>

							{!isReadOnly && (
								<Styled.ChangePasswordContainer>
									<Button
										onClick={() => setChangePasswordDialogVisible(true)}
										color="secondary"
									>
										{t('Change password')}
									</Button>
								</Styled.ChangePasswordContainer>
							)}
						</div>
					)}
				</Styled.Section>
			</Styled.Body>
		</Styled.BusinessProfileContainer>
	);
};

export default UserProfile;
